import { Box, Divider } from "@mui/material";
import ContractualPayroleReport from "../Reports/PSRContractual/ContractualPayroleReport";
import ContractualPSRNotProcessedEmployee from "../Reports/PSRContractual/ContractualPSRNotProcessedEmp";

const ContractualEmployees = ({
  selectedYear,
  selectedMonth,
  currentMonthData,
  userRole,
  paydate,
  worklocationData,
  handleWorkLoacation,
}) => {
  const readOnly = () => {
    if (userRole === "both") {
      if (currentMonthData?.["Contractual_status"] === "Action Needed") {
        return true;
      } else {
        return false;
      }
    } else if (userRole === "approver") {
      return true;
    } else if (userRole === "admin") {
      return currentMonthData?.["Contractual_status"] === "Action Needed";
    }
  };
  return (
    <Box>
      <ContractualPayroleReport
        selectedYear={selectedYear}
        selectedMonth={selectedMonth}
        currentMonthData={currentMonthData}
        readOnly={readOnly()}
        userRole={userRole}
        paydate={paydate}
        worklocationData={worklocationData}
        handleWorkLoacation={handleWorkLoacation}
      />
      <Divider sx={{ my: 3 }} />
      <ContractualPSRNotProcessedEmployee
        selectedYear={selectedYear}
        selectedMonth={selectedMonth}
        currentMonthData={currentMonthData}
        readOnly={readOnly()}
        paydate={paydate}
        worklocationData={worklocationData}
        handleWorkLoacation={handleWorkLoacation}
      />
    </Box>
  );
};

export default ContractualEmployees;
